import React from "react";
import { Helmet } from "react-helmet";

export default function HelmetForTitle({
  keywords = "",
  title = "",
  description = "",
  ogTitle = "",
  ogDescription = "",
  ogImage = "",
  ogUrl = "",
  canonicalUrl = "",
  ogType = "",
  ogSiteName = "",
  twitterCard = "",
}) {
  return (
    <Helmet>
      {/* <title>Eigennet - Engineering The Mission With Innovation!</title> */}
      <meta name="keyword" content={keywords} />
      <title>{title}</title>
      <meta name="description" charSet="utf-8" content={description} />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={ogUrl} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={ogSiteName} />
      <meta name="twitter:title" content={ogTitle} />
      <meta name="twitter:description" content={ogDescription} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:card" content={twitterCard} />
    </Helmet>
  );
}
